import { Entity } from 'types';
import { BoolIcon } from 'components/Icon';
import { formatDate, formatDateTime } from 'utilities';
import { getIn } from 'final-form';
import { Box, TableColumn } from '@ff-it/ui';
import { Period } from './ui';

export function bool<T extends Entity>(
  Header: string,
  key: Extract<keyof T, string>,
  props?: Partial<TableColumn<T>>,
): TableColumn<T> {
  return {
    content: Header,
    key,
    cellProps: {
      textAlign: 'center',
    },
    render: (e) => (e[key] === null ? null : <BoolIcon>{e[key] as boolean}</BoolIcon>),
    width: 120,
    ...props,
  };
}

export function date<T extends Entity>(
  Header: string,
  key: Extract<keyof T, string | null> | string,
  { cellProps, ...props }: Partial<TableColumn<T>> = {},
): TableColumn<T> {
  return {
    content: Header,
    key,
    cellProps: {
      textAlign: 'left',
      ...cellProps,
    },
    width: '115px',
    render: (e) => {
      const v = getIn(e, key);

      return e && v ? (formatDate(v) as any) : null;
    },
    ...props,
  };
}

export const periodColumn: TableColumn<{ date_from: string | null; date_to: string | null }> = {
  key: 'date_from',
  content: 'Period',
  cellProps: {
    textAlign: 'left',
    className: 'py-0',
  },
  width: 95,
  sortable: true,
  render: ({ date_from, date_to }) => <Period date_from={date_from} date_to={date_to} />,
};

export function period<T extends Entity>(
  Header: string,
  key: Extract<keyof T, string | null> | string,
  { cellProps, ...props }: Partial<TableColumn<T>> = {},
): TableColumn<T> {
  return {
    content: Header,
    key,
    cellProps: {
      textAlign: 'left',
      ...cellProps,
    },
    width: '115px',
    render: (e) => {
      const v = getIn(e, key);

      return e && v ? (formatDate(v) as any) : null;
    },
    ...props,
  };
}

export function dateFrom(props?: Partial<TableColumn<any>>): TableColumn<any> {
  return date('Date from', 'date_from' as any, {
    width: '115px',
    ...props,
  });
}

export function dateTo(props?: Partial<TableColumn<any>>): TableColumn<any> {
  return date('Date to', 'date_to' as any, {
    width: '115px',
    ...props,
  });
}

export function timestamp<T extends Entity>(
  Header: string,
  key: Extract<keyof T, string>,
  props?: Partial<TableColumn<T>>,
): TableColumn<T> {
  return {
    content: Header,
    key,
    cellProps: {
      textAlign: 'left',
      className: 'py-0',
    },
    minWidth: 80,
    render: (e) => (
      <Box textSize="xs" lineHeight="1">
        {e[key] ? formatDateTime(e[key] as any) : null}
      </Box>
    ),
    ...props,
  };
}
